import { render } from "./PoseDrawerTest.vue?vue&type=template&id=2804ff56"
import script from "./PoseDrawerTest.vue?vue&type=script&lang=ts"
export * from "./PoseDrawerTest.vue?vue&type=script&lang=ts"

import "./PoseDrawerTest.vue?vue&type=style&index=0&id=2804ff56&lang=css"
script.render = render

export default script